/** @format */

import { useContext, useEffect, useState } from 'react';

import { Link, useLocation, useParams } from 'react-router-dom';

import { EventContext } from '../../Contexts/EventContext';
import Loading from '../../Shared/Components/Loading';
import Pagination from '../../Shared/Components/Pagination';
import { error } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import { countOfRecourd, isEndedEvent } from '../../Shared/utils/helper';
import Master from '../Layouts/Master';

const TeamEventRegister = () => {
  const eventContext = useContext(EventContext);
  const { id } = useParams();
  const { search } = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getTeam();
  }, [search, id]);

  const getTeam = async () => {
    setLoading(true);
    await useApi.get(
      `/event/${id}`,
      {},
      (res) => {
        eventContext.event = res.data.data;
      },
      (err) => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
    await useApi.get(
      `/team/my-team/${id}${search}`,
      {},
      (res) => {
        eventContext.teams = res.data;
      },
      (err) => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
    setLoading(false);
  };

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <div className='w-100 overflow-auto'>
        {eventContext.teams?.data?.length > 0 ? (
          <table className='table table-hover'>
            <thead>
              <tr>
                <th>#</th>
                <th>نام سرپرست</th>
                <th>{id == 11 ? 'نام سازمان' : 'نام باشگاه'}</th>
                <th>{id == 11 ? 'شماره تماس' : 'تلفن باشگاه'}</th>
                <th>استان</th>
                <th>شهرستان</th>
                <th>آدرس باشگاه</th>
                <th>نام سرپرست</th>
                <th>تلفن سرپرست</th>
                <th>عکس سرپرست</th>
                <th>عکس تیمی</th>
                <th>کاربران ثبت نام شده</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {eventContext.teams?.data?.map((item, index) => (
                <tr key={item.id}>
                  <th>
                    {countOfRecourd(
                      index,
                      eventContext.teams?.meta?.pagination?.per_page,
                      eventContext.teams?.meta?.pagination?.current_page,
                    )}
                  </th>
                  <td>
                    {item?.supervisor?.first_name ?? '-'}{' '}
                    {item?.supervisor?.last_name ?? '-'}
                  </td>
                  <td>{item?.club_name ?? '-'}</td>
                  <td>{item?.club_phone ?? '-'}</td>
                  <td>{item?.province?.name ?? '-'}</td>
                  <td>{item?.city ?? '-'}</td>
                  <td>{item?.club_address ?? '-'}</td>
                  <td>{item?.supervisor_name ?? '' ?? '-'}</td>
                  <td>{item?.supervisor_phone ?? '-'}</td>
                  <td>
                    {item?.supervisor_img !== null ? (
                      <img
                        src={item?.supervisor_img}
                        className='w-100'
                        alt={item?.club_name}
                      />
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>
                    {item?.team_picture !== null ? (
                      <img
                        src={item?.team_picture}
                        className='w-100 img-thumbnail'
                        style={{ width: '60px', height: '60px' }}
                        alt={item?.club_name}
                      />
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>
                    <Link
                      to={`/panel/user/event/${id}/team/${item.id}/users`}
                      className='btn btn-info btn-sm d-flex flex-row justify-content-center p-2'
                    >
                      <i className='fad fa-eye text-dark-mode f-15'></i>
                    </Link>
                  </td>

                  <td>
                    {isEndedEvent(eventContext.event) ? (
                      '-'
                    ) : (
                      <div className='d-flex flex-row'>
                        <Link
                          to={`/user/event/${id}/register/edit`}
                          state={{ teamId: item.id }}
                          className='mx-2'
                        >
                          ویرایش
                        </Link>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className='d-flex flex-row justify-content-center border p-3 my-3	'>
            <span className='f-13 font-weight-bold text-secondary'>
              کاربری ثبت نام نکرده است
            </span>
          </div>
        )}
      </div>
      <Pagination
        totalPage={eventContext.teams?.meta?.pagination?.total_pages}
        basePath={`/panel/event/${id}/team`}
        search={search}
      />
    </Master>
  );
};

export default TeamEventRegister;
